import { render, staticRenderFns } from "./moduleDetails.vue?vue&type=template&id=9c40bcda&"
import script from "./moduleDetails.vue?vue&type=script&lang=js&"
export * from "./moduleDetails.vue?vue&type=script&lang=js&"
import style0 from "./moduleDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports